<template>
    <div class="pageTitleBox" :class="{'ismobile':isMobile}">
        <div class="subShop" v-if="shopDataText && !noshowshop">
            <div class="subShopBox" @click="openShopType">
                <span>{{shopDataText}}</span><i class="iconfont icon-a-zu1476"></i>
            </div>
        </div>
        <div class="htop" :class="{'active':showreturn}">
            <div class="title " >
                <i @click.stop="returnPage" class="iconfont icon-a-zu88" v-if="showreturn"></i>
                <div class="sutitle">{{title}}</div>
            </div>
            <template v-if="code=='keyinfo_index'">
                <div class="buttonBox">
                    <el-button type="default" @click="openHistory">{{$t('History')}}</el-button>
                </div>
            </template>
            <template v-if="code=='Report_index'">
                <div class="buttonBox active">
                    <el-button type="default" @click="openHistory">{{$t('rHistory')}}</el-button>
                </div>
            </template>
            <template v-else-if="code=='contact_index'">
                <div class="buttonBox active">
                    <el-button type="default" @click="openHistory">{{$t('cHistory')}}</el-button>
                    <el-button type="default" @click.stop="editContact()" :loading="saveload">{{$t('ApplyChange')}}</el-button>
                </div>
            </template>
            <template v-else-if="code=='contact_edit' || code=='FittingOut_email'">
                <div class="buttonBox active">
                    <el-button type="default" @click.stop="checkEdie()" :loading="saveload">{{$t('Submit')}}</el-button>
                </div>
            </template>
            <template v-else-if="code=='FittingOut_detail'">
                <div class="buttonBox active">
                    <!-- <el-button type="default" @click="openEmail" v-if="showTypeMode">{{$t('SubmitbyContractor')}}</el-button> -->
                    <el-button type="default" @click.stop="submitFittingOut()" v-if="showSubmit">{{$t('Submit')}}</el-button>
                    <el-button type="default" v-if="showSubmitWc">{{$t('Submission')}}</el-button>
                </div>
            </template>
            <template v-else-if="code=='WorkApplication_index'">
                <div class="buttonBox active">
                    <el-button type="default" @click.stop="openUpload">{{$t('nxxUpdate')}}</el-button>
                    <el-button type="default" @click.stop="openApply">{{$t('newApply')}}</el-button>
                </div>
            </template>
            <template v-else-if="code=='WorkApplication_upload'">
                <div class="buttonBox">
                    <el-button type="default" @click.stop="openHistory">{{$t('UploadHistory')}}</el-button>
                </div>
            </template>
        </div>
        <template v-if="code=='FittingOut_view'">
            <div class="helpTip" v-if="LastUpdateTimex">{{$t('LastUpdateTime')}}:{{LastUpdateTimex}}</div>
        </template>
    </div>
</template>

<script>
export default {
    props:{
        title: {
            type: String,
            default: ''
        },
        btitle: {
            type: String,
            default: ''
        },
        showreturn: {
            type:Boolean,
            default:false
        },
        code:{
            type: String,
            default: ''
        },
        saveload: {
            type:Boolean,
            default:false
        },
        showSubmit:{
            type:Boolean,
            default:false
        },
        showSubmitWc:{
            type:Boolean,
            default:false
        },
        LastUpdateTimex:{
            type:String,
            default:""
        },
        noshowshop:{
            type:Boolean,
            default:false
        },
       
    },
    computed:{
        shopData(){
            return this.$store.state.app.shopData
        },
        shopDataText(){
            let shopxx=this.$store.state.app.shopData
            if(shopxx){
                return shopxx.Building+', '+shopxx.Floor+', '+shopxx.Unit
            }else{
                return false
            }
        },
        showTypeMode(){
            let UserData=this.$store.state.app.UserData
            if(UserData && UserData.hasOwnProperty('type') && UserData.type==2){
                return false
            }else{
                return true
            }
        },
        isMobile() {
        　　let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        　　return flag;
        }
    },
    mounted(){

    },
    methods:{
        returnPage(){
            let shopxx=this.shopData
            sessionStorage.setItem('trueBack',true)//是否是回退
            //判断
            if(this.code=='keyinfo_history'&&shopxx&&shopxx.PropertyType){
                this.$router.push({path:'/keyinfo/index',query:{shopId:(shopxx.PropertyType+'_'+shopxx.Building+'_'+shopxx.Floor+'_'+shopxx.Unit)}})
            }else if(this.code=='contact_history'){
                this.$router.push({path:'/contact/index'})
            }else if(this.code=='keyinfo_index'){
                this.$router.push({path:'/keyinfo'})
            }else if(this.code=='User_resetPassword'){
                this.$router.push({path:'/'})
            }else{
                this.$router.back()
            }
        },

        //更改
        checkEdie(){
            if(this.saveload){
                return false
            }

            //判断
            if(this.code=='FittingOut_email'){
                this.$emit('editEmail', false)
            }else{
                this.$emit('editContact', false)
            }
        },

        //打开历史
        openHistory(){
            let that=this
            let shopxx=this.$store.state.app.shopData
            switch(this.code){
                case 'keyinfo_index':
                    if(shopxx){
                        this.$router.push({path:'/keyinfo/history',query:{shopId:(shopxx.PropertyType+'_'+shopxx.Building+'_'+shopxx.Floor+'_'+shopxx.Unit)}})
                    }
                    break
                case 'contact_index':
                    that.$router.push({path:'/contact/history'})
                    break
                case 'Report_index':
                    that.$router.push({path:'/Report/history'})
                    break
                case 'WorkApplication_upload':
                    if(shopxx){
                        that.$router.push({path:'/WorkApplication/uploadHistory',query:{shopId:(shopxx.PropertyType+'_'+shopxx.Building+'_'+shopxx.Floor+'_'+shopxx.Unit)}})
                    }
                    break
            }
        },

        //打開Upload
        openUpload(){
            let shopxx=this.$store.state.app.shopData
            this.$router.push({path:'/WorkApplication/upload',query:{shopId:(shopxx.PropertyType+'_'+shopxx.Building+'_'+shopxx.Floor+'_'+shopxx.Unit)}})
        },

        //打開Apply
        openApply(){
            let shopxx=this.$store.state.app.shopData
            this.$router.push({path:'/WorkApplication/Apply',query:{shopId:(shopxx.PropertyType+'_'+shopxx.Building+'_'+shopxx.Floor+'_'+shopxx.Unit)}})
        },

        //打开店铺
        openShopType(){
            let that=this
            let xcode=this.code
            if(xcode){
                xcode=xcode.split('_')
                console.log('xcode',xcode)
                if(xcode && xcode.length>0){
                    this.$router.push({path:'/'+xcode[0]})
                }
            }

        },

        //打开email
        openEmail(){
            this.$emit('openEmail', null);
            // this.$router.push({path:'/FittingOut/email'})
        },

        //申请修改
        editContact(){
            if(this.saveload){
                return false
            }
            this.$emit('openContact', false)
        },

        //选择店铺
        checkShop(){
            this.$emit('selectShop', null);
        },

        //提交
        submitFittingOut(){
            this.$emit('submitFittingOut', null);
        }
    }
}
</script>

<style lang="scss" scoped>
.pageTitleBox{
    padding: 27px 35px;
    padding-top: 30px;
    position: relative;
    z-index: 2;
    @media screen and (max-width: 992px){
       padding: 0;
    }
    &.ismobile{
        padding: 0;
        padding-bottom: 15px;
        @media screen and (max-width: 992px){
            padding-bottom: 1vh;
        }
    }
    
}
.subShop{
    display: flex;
    margin-bottom: 20px;
     @media screen and (max-width: 992px){
        width: 100%;
        margin-bottom: 1vh;
     }
    .subShopBox{
        padding: 12px 15px;
        border:3px solid $ThemeColor;
        border-radius: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;
        transition:all .2s;
        @media screen and (max-width: 992px){
          width: 100%;
          box-sizing: border-box;
          padding: 1vh 2vw;
        //   margin-top: 3vh;
          line-height: normal;
        }
        span{
            font-size: 18px;
            font-weight: bold;
            color: $ThemeColor;
             @media screen and (max-width: 992px){
                width: 100%;
                display: inline-block;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
               font-size: 2.6vw;
               text-align: left;
             }
        }
        i{
            color: #AAB300;
            margin-left: 25px;
            font-size: 20px;
            @media screen and (max-width: 992px){
              margin-left: 5vw;
              font-size: 4.2vw;
            }
        }
        &:hover{
            background: $ThemeColor;
            span{
                color: #fff;
            }
        }
    }
}
.htop{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 45px;
    @media screen and (max-width: 992px){
        // height: 9vw;
        height: auto;
        display: flex;
        flex-wrap: wrap;
    }
    .title{
        font-size: 28px;
        font-weight: bold;
        color: $ThemeColor;
        display: flex;
        flex-direction: row;
        align-items: center;
        @media screen and (max-width: 992px){
          font-size:5.2vw;
          align-items: flex-start;
          flex-grow: 0;
        }
        i{
            font-size: 24px;
            margin-right: 30px;
            cursor: pointer;
            @media screen and (max-width: 992px){
               font-size: 5vw;
                margin-right: 1vw;
                display: flex;
            }
        }
        .sutitle{
            display: flex;
            flex-direction: row;
            align-items: center;
            @media screen and (max-width: 992px){
              margin-left: 3vw;
            }
            span{
                font-size: 18px;
                margin-left: 3px;
            }
        }
    }
    .buttonBox{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        @media screen and (max-width: 992px){
            position: fixed;
            bottom: 4vh;
            flex-direction: column;
            width: 92%;
            background: #fff;
        }   
        .el-button{
            border: 2px solid $ThemeColor;
            border-radius: 5px;
            color: $ThemeColor;
            font-size: 14px;
            &:hover{
                background:$ThemeColor;
                color: #fff;
            }
            @media screen and (max-width: 992px){
              padding: 2vw;
              width: 100%;
              margin: 1vh 0;
              width: 92%;
            }
        }
        .el-button+.el-button{
            margin-left: 15px;
            @media screen and (max-width: 992px){
                margin-left: 0;
            }
        }
    }
    .buttonBox.active{
        .el-button{
            background: $ThemeColor;
            color: #fff;
            &:hover{
                opacity: 0.9;
            }
        }
    }
}
.htop.active{
    // padding-bottom: 0;
}
.helpTip{
    text-align: left;
    margin-left: 54px;
    color: $ThemeColor;
    font-size: 16px;
    font-weight: bold;
    margin-top: 5px;
}
@media screen and (max-width: 992px){
    .el-button {
        padding: 2vw 4vw;
        font-size: 3.6vw!important;
    }
}
// 橫屏
 @media screen and (min-aspect-ratio: 13/9){
     .htop{
         .title{
           font-size: 28px;
           i{
            font-size: 24px;
           }
         }
     }
 }
</style>



// WEBPACK FOOTER //
// src/components/pageTitle.vue